import { API_URL } from "../util/apiPaths";
import { request } from "./api.js";

/* Add eventType */
export function addEventType( params ) {
  return request( "POST", API_URL.PARTNER_EVENT_TYPES, params );
}

/* Get partner's eventType list */
export function getPartnerEventTypes( params ) {
  return request( "GET", API_URL.PARTNER_EVENT_TYPES, params );
}

/* Update partner's eventType */
export function updatePartnerEventType( params ) {
  return request( "PUT", API_URL.PARTNER_EVENT_TYPES, params );
}

/* Get partner's eventType detail */
export function getPartnerEventTypeDetail( params ) {
  return request( "GET", `${ API_URL.PARTNER_EVENT_TYPES }/${ params }` );
}

export const partnerGameServices = {
  addEventType,
  getPartnerEventTypes,
  updatePartnerEventType,
  getPartnerEventTypeDetail,
};
